import { HTMLAttributes } from 'react';

import { cn } from '@components/primitives';

import css from './styles.module.css';

export function CardSection({
  children,
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn(css.section, className)} {...props}>
      {children}
    </div>
  );
}
